"use strict";

define('rs/modals/proposal.finder/proposal.finder.controller',['rs/modals/table.finder/table.finder.controller', './proposal.finder.view', 'rs/models/proposal.sp'], function (RSFinderController, ProposalFinderView, SPProposal) {
  var ProposalFinderController = RSFinderController.extend({
    defaultTitle: 'Proposal Finder',
    properties: ['people', 'proposals'],
    columns: [{
      accessor: 'number',
      displayName: 'Number',
      type: 'String',
      width: '18%'
    }, {
      accessor: 'status',
      displayName: 'Status',
      type: 'String',
      width: '18%'
    }, {
      accessor: 'beginDate',
      displayName: 'Begin Date',
      type: 'date',
      format: "MM/DD/YYYY",
      width: '18%'
    }, {
      accessor: 'endDate',
      displayName: 'End Date',
      type: 'date',
      format: "MM/DD/YYYY",
      width: '18%'
    }, {
      accessor: 'leadDisplayName',
      displayName: 'Lead PI',
      type: 'String',
      width: '21%'
    }, {
      icon: 'plus',
      className: 'btn-add-member',
      width: '7%',
      sortable: false
    }],
    setupView: function setupView() {
      this.setView(new ProposalFinderView());
    },
    generateDisplayName: function generateDisplayName(item) {
      return item.getNumber();
    },
    defaultProperties: function defaultProperties() {
      return _.extend(this._super(), {
        showFilter: false
      });
    },
    getLegacyCayuseIds: function getLegacyCayuseIds() {
      return _.chain(this.getPeople()).pluck('legacyCayuseId').compact().value();
    },
    getPeopleWithLegacyCayuseIds: function getPeopleWithLegacyCayuseIds() {
      return _.filter(this.getPeople(), function (person) {
        return !!person.getLegacyCayuseId();
      });
    },
    sectionIsReady: function sectionIsReady() {
      var promise = Promise.resolve(this.getLegacyCayuseIds()).bind(this).then(function (legacyCayuseIds) {
        if (_.isEmpty(legacyCayuseIds)) {
          return [];
        } else {
          return SPProposal.requestAll(legacyCayuseIds);
        }
      }).map(function (proposal) {
        return proposal.toProposal();
      }).tap(this.setProposals);
      this.setProposals(promise);
      return this._super();
    },
    _requestTableItems: function _requestTableItems() {
      return Promise.resolve(this.getProposals() || []);
    }
  });
  return ProposalFinderController;
});

